import './Banner.css'

const Banner = () => {
    return(
        <header className='banner'>
            <img src='/images/banner.jpg' alt='Banner pagina principal'/>
        </header>
    )
}

export default Banner